<ion-grid>
	<ion-row>
		<ion-col>
			<ion-grid
				class="max-w-1336"
				*ngIf="allCommunities$ | async as communities"
			>
				<ng-container *ngIf="communities.isSkeleton">
					<ion-grid class="side-menu-wrapper text-center">
						<ion-spinner class="ion-spinner"></ion-spinner>
					</ion-grid>
				</ng-container>
				<ion-row>
					<ion-col col="12" *ngIf="communities.data">
						<dx-data-grid
							id="gridContainer"
							[dataSource]="communities.data"
							[allowColumnResizing]="true"
							[columnAutoWidth]="true"
							[showBorders]="true"
						>
							<dxo-search-panel
								[visible]="true"
								[width]="240"
								placeholder="Search..."
							></dxo-search-panel>
							<dxo-header-filter></dxo-header-filter>
							<dxo-column-chooser
								[enabled]="true"
								mode="select"
							></dxo-column-chooser>
							<dxo-column-fixing [enabled]="true"></dxo-column-fixing>

							<!-- <dxi-column
								caption="Action"
								dataField="id"
								[allowFiltering]="false"
								[allowSorting]="false"
								cellTemplate="cellTemplate"
								[width]="70"
								[fixed]="true"
								[visible]="true"
							>
							</dxi-column> -->

							<dxi-column
								caption="Photo"
								dataField="photo"
								[allowFiltering]="false"
								[allowSorting]="false"
								cellTemplate="cellTemplate2"
								[width]="150"
								[fixed]="true"
								[visible]="false"
							>
							</dxi-column>

							<dxi-column
								dataField="name"
								caption="Community Name"
								[width]="230"
								[fixed]="true"
							></dxi-column>

							<dxi-column
								dataField="tagline"
								caption="Community Tagline"
								[width]="230"
								[fixed]="true"
							></dxi-column>
							<dxi-column
								dataField="about_community"
								caption="About Community"
								[width]="230"
								[fixed]="true"
							></dxi-column>
							<dxi-column
								dataField="community_norms"
								caption="Community Norms"
								[width]="230"
								[fixed]="true"
							></dxi-column>
							<!-- <div *dxTemplate="let d of 'cellTemplate'">
								<div
									class="text-center cursor-pointer"
									(click)="getEmailAndUpdate(d.data)"
								>
									Edit
								</div>
							</div> -->

							<div *dxTemplate="let d of 'cellTemplate2'">
								<img [src]="d.data.photo" alt="" class="community-img" />
							</div>
							<dxo-toolbar>
								<dxi-item location="before">
									<div *dxTemplate class="informer">
										<ion-button (click)="addCommunity()"
											><ion-icon name="add-outline"></ion-icon
										></ion-button>
									</div>
								</dxi-item>
								<dxi-item location="before">
									<div *dxTemplate class="informer">
										<p class="Heading_M">Add New Community</p>
									</div>
								</dxi-item>
								<dxi-item name="columnChooserButton"></dxi-item>
								<dxi-item name="searchPanel"></dxi-item>
							</dxo-toolbar>
						</dx-data-grid>
					</ion-col>
				</ion-row>
			</ion-grid>
		</ion-col>
	</ion-row>
</ion-grid>
